import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon/snack-outline-blue.svg'
import _imports_1 from '@/assets/img/icon/eye-outline-blue.svg'
import _imports_2 from '@/assets/img/icon/change-outline-blue.svg'


const _hoisted_1 = { class: "mr-5" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-3 w-4",
  alt: "addSnack"
}, null, -1)
const _hoisted_4 = { class: "color-grey-5" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-3 w-4",
  alt: "detailSnack"
}, null, -1)
const _hoisted_7 = { class: "color-grey-5" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mr-3 w-4",
  alt: "returnSnack"
}, null, -1)
const _hoisted_10 = { class: "color-grey-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      ($props.addSnack)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: "cursor-pointer py-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('addSnack')))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, _toDisplayString($props.addSnackTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.detailSnack)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: "cursor-pointer py-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('detailSnack')))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString($props.detailSnackTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.returnSnack)
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            class: "cursor-pointer py-1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('returnSnack')))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString($props.returnSnackTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}